<template>
  <v-app>
    <Confirm ref="confirm"></Confirm>
    <notifications classes="notification" position="top right" />
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <p>Loading...</p>
    </v-overlay>
    <component :is="layout">
      <transition name="fade">
        <router-view />
      </transition>
    </component>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import './assets/styles/main.scss';
import store from './store';
import ErrorUtil from './utils/errorMessage';
import moment from 'moment';
import authService from './services/auth';
import '@mdi/font/css/materialdesignicons.css';

const default_layout = 'app';

export default {
  store,
  data() {
    return {
      loadingData: false,
    };
  },
  computed: {
    layout() {
      return (store.state.route.meta.layout || default_layout) + '-layout';
    },
    currentAmountLoading() {
      return store.getters['loading/loadingAmount'];
    },
    ...mapGetters({
      isActive: 'loading/isLoading',
    }),
  },
  watch: {
    isActive(val) {
      this.loadingData = val;
    },
  },
  beforeMount() {},
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  },
  created() {
    // Add a request interceptor
    window.axios.interceptors.request.use(
      (config) => {
        if (!config.headers.ignoreLoading) this.setLoading(true);
        return config;
      },
      (error) => {
        // Do something with request error
        this.setLoading(false);

        return Promise.reject(error);
      }
    );

    // Auto-logout when received 401 or has beed idle for too long
    window.axios.interceptors.response.use(
      (response) => {
        // Do something with response data
        store.dispatch('auth/setLastActiveTime', moment());

        this.setLoading(false);

        // set lang if not matched
        // console.log(response);
        // console.log(response.headers['content-language']);
        return response;
      },
      (error) => {
        // Do something with response error

        this.setLoading(false);

        ErrorUtil.notification(error);

        if (error.response && error.response.status === 401) {
          let redirect = null;
          if (store.state.route.meta.authType) {
            redirect = 'login';
          }
          authService.logout(redirect);
        }
        return Promise.reject(error);
      }
    );
  },
  methods: {
    setLoading(isLoading) {
      store.dispatch('loading/setLoading', isLoading);
      if (this.isActive) {
        store.dispatch('loading/add');
      } else if (this.currentAmountLoading > 0) {
        store.dispatch('loading/complete');
        store.dispatch('loading/setLoading', this.currentAmountLoading > 0);
      }
    },
  },
  components: {},
};
</script>

<style lang="scss">
.notification {
  padding: 10px;
  margin: 5px 5px 5px;
  font-size: 14px;
  min-height: 80px;
  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;
}
.datepicker {
  width: 312px !important;
  max-width: 312px !important;
}
.datepicker-container {
  width: 100% !important;
}
.field-label {
  top: 10px !important;
  left: 20px !important;
}
</style>
